import axios from "axios";
import { apiURL } from "./getAPIURL.js";

export default async function requestApi(
  endPoint,
  parameters,
  method = "get",
  model = "product"
) {
  const URL = `${apiURL}${endPoint}`;
  const OPTIONS = {
    headers: {
      "Cache-Control": "no-cache",
      "Content-Type": "application/json",
    },
  };
  switch (method) {
    case "get":
      switch (model) {
        case "order":
          return await axios.get(
            URL,
            {
              params: {
                idUser: parameters.idUser,
                ...parameters
              },
            },
            OPTIONS
          );

        case "product":
          return await axios.get(
            URL,
            {
              params: {
                idProduct: parameters,
              },
            },
            OPTIONS
          );

        case "user":
          return await axios.get(
            URL,
            {
              params: {
                idUser: parameters.idUser,
                idAuth: parameters.idAuth,
              },
            },
            OPTIONS
          );
        default:
          break;
      }
      break;

    case "delete":
      OPTIONS.source = parameters;
      const OPTIONS_DELETE = {
        headers: {
          "Cache-Control": "no-cache",
          "Content-Type": "application/json",
        },
        data: {
          source: parameters,
        },
      };
      return axios.delete(URL, OPTIONS_DELETE);

    case "patch":
      return axios.patch(URL, parameters, OPTIONS);

    case "post":
      return axios.post(URL, parameters, OPTIONS);

    default:
      break;
  }
}

export async function api(endPoint, { method = "get", body } = {}) {
  const URL = `${apiURL}${endPoint}`;
  const header = {
    "Cache-Control": "no-cache",
    "Content-Type": "application/json",
  };

  const res = await fetch(URL, {
    header,
    method,
    body: body ? body : null,
  });

  return res.json();
}

export function get(endPoint, paramsReq) {
  const URL = `${apiURL}${endPoint}`;
  const OPTIONS = {
    headers: {
      "Cache-Control": "no-cache",
      "Content-Type": "application/json",
    },
  };
  return axios.get(
    URL,
    {
      params:
        paramsReq,

    },
    OPTIONS
  );
}